import { render, staticRenderFns } from "./mytasks.vue?vue&type=template&id=4a79dc29&"
import script from "./mytasks.vue?vue&type=script&lang=js&"
export * from "./mytasks.vue?vue&type=script&lang=js&"
import style0 from "./mytasks.vue?vue&type=style&index=0&id=4a79dc29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports